import React from 'react';
import LegalPage from './LegalPage';

const Privacidad = () => {
  const sections = [
    {
      heading: 'Introducción',
      paragraphs: [
        'En SEBINOR Computación valoramos tu privacidad y nos comprometemos a proteger tus datos personales. Esta Política de Privacidad explica qué información recopilamos, cómo la utilizamos y qué derechos tenés sobre tus datos.',
        'Al utilizar nuestro sitio o nuestros servicios, aceptás las prácticas descriptas en este documento.'
      ]
    },
    {
      heading: 'Responsable del tratamiento',
      paragraphs: [
        'El responsable del tratamiento de los datos personales es SEBINOR Computación, con domicilio comercial en Av. Libertador 7615. Para cualquier consulta relacionada con tu privacidad podés escribirnos a sebinorcomputacion@yahoo.com.'
      ]
    },
    {
      heading: 'Datos que recopilamos',
      paragraphs: [
        'Según la interacción que tengas con nosotros podemos recopilar los siguientes datos:'
      ],
      bullets: [
        'Datos de contacto: nombre, teléfono, correo electrónico y dirección.',
        'Datos del equipo o producto consultado al pedir presupuesto o servicio técnico.',
        'Datos de navegación: dirección IP, tipo de dispositivo, navegador y páginas visitadas.',
        'Mensajes enviados a través de WhatsApp, correo o formularios de contacto.'
      ]
    },
    {
      heading: 'Finalidad del tratamiento',
      paragraphs: [
        'Utilizamos tu información únicamente con fines legítimos y relacionados con nuestra actividad:'
      ],
      bullets: [
        'Responder consultas, cotizaciones y pedidos de servicio técnico.',
        'Coordinar la entrega, retiro o visita técnica de equipos.',
        'Enviarte información sobre el estado de tu equipo o presupuesto.',
        'Mejorar nuestros servicios y la experiencia de uso del sitio.',
        'Cumplir con obligaciones legales, fiscales o contables.'
      ]
    },
    {
      heading: 'Base legal',
      paragraphs: [
        'El tratamiento de tus datos se basa en tu consentimiento al contactarnos, en la ejecución de la relación comercial o servicio solicitado, y en el cumplimiento de obligaciones legales aplicables.'
      ]
    },
    {
      heading: 'Compartición de datos',
      paragraphs: [
        'No vendemos, alquilamos ni cedemos tus datos personales a terceros con fines comerciales. Sólo podemos compartir información con:'
      ],
      bullets: [
        'Prestadores de servicios logísticos cuando sea necesario coordinar un retiro o entrega.',
        'Autoridades públicas cuando exista una obligación legal de informar.',
        'Proveedores de infraestructura (hosting, mensajería) estrictamente para el funcionamiento del sitio.'
      ]
    },
    {
      heading: 'Cookies y tecnologías similares',
      paragraphs: [
        'El sitio puede utilizar cookies técnicas y analíticas para mejorar la navegación, recordar preferencias y medir el uso del sitio. Podés configurar tu navegador para rechazar o eliminar las cookies, aunque esto podría afectar algunas funcionalidades.'
      ]
    },
    {
      heading: 'Conservación de los datos',
      paragraphs: [
        'Conservamos tus datos personales durante el tiempo necesario para cumplir con la finalidad para la que fueron recopilados, atender eventuales reclamos y cumplir con las obligaciones legales aplicables. Luego serán eliminados o anonimizados de forma segura.'
      ]
    },
    {
      heading: 'Seguridad',
      paragraphs: [
        'Adoptamos medidas técnicas y organizativas razonables para proteger tus datos contra accesos no autorizados, pérdida, alteración o divulgación. No obstante, ningún sistema conectado a internet puede garantizar seguridad absoluta.'
      ]
    },
    {
      heading: 'Tus derechos',
      paragraphs: [
        'De acuerdo con la Ley 25.326 de Protección de Datos Personales de la República Argentina, podés ejercer en cualquier momento los siguientes derechos:'
      ],
      bullets: [
        'Acceso: solicitar qué datos tuyos tenemos.',
        'Rectificación: pedir la corrección de datos inexactos o incompletos.',
        'Supresión: solicitar la eliminación de tus datos cuando ya no sean necesarios.',
        'Oposición: oponerte al uso de tus datos para determinadas finalidades.'
      ]
    },
    {
      heading: 'Menores de edad',
      paragraphs: [
        'Nuestro sitio no está dirigido a menores de 18 años. No recopilamos de forma intencional información personal de menores sin el consentimiento verificable de sus padres o tutores.'
      ]
    },
    {
      heading: 'Cambios en esta política',
      paragraphs: [
        'Podemos actualizar esta Política de Privacidad para reflejar cambios en nuestros servicios o en la normativa aplicable. La versión vigente estará siempre disponible en esta página con la fecha de última actualización.'
      ]
    },
    {
      heading: 'Contacto',
      paragraphs: [
        'Para ejercer tus derechos o realizar consultas sobre esta política podés escribirnos a sebinorcomputacion@yahoo.com, enviarnos un WhatsApp al +54 9 15 2610-6011 o acercarte personalmente a Av. Libertador 7615.'
      ]
    }
  ];

  return (
    <LegalPage
      title="Política de privacidad"
      subtitle="Cómo recopilamos, usamos y protegemos tus datos personales en SEBINOR Computación."
      lastUpdated="Diciembre 2025"
      sections={sections}
    />
  );
};

export default Privacidad;
